import { InputAdornment, TextField } from "@mui/material"

export default function CurrencyInputDefaults() {
  return {
    size: "small",
    fullWidth: true,
    customInput: TextField,
    InputProps: {
      startAdornment: <InputAdornment position="start">$</InputAdornment>,
    },
    decimalScale: 2
  };
}
